// src/components/CreateTeamModal.js
import { useState } from 'react';
import axios from 'axios';
import { FiX } from 'react-icons/fi';
import { createTeam } from '../../services/action';

// Add this CSS to your stylesheet
const styles = `
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1050;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal-content {
    background: white;
    border-radius: 0.5rem;
    width: 100%;
    max-width: 500px;
    margin: 1rem;
  }

  .modal-header {
    padding: 1rem;
    border-bottom: 1px solid #dee2e6;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .error-alert {
    background-color: #f8d7da;
    border-color: #f5c2c7;
    color: #842029;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.375rem;
  }
`;

const CreateTeamModal = ({ isOpen, onClose, onTeamCreated }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await createTeam(name, description);
      onTeamCreated(res.data.data);
      onClose();
      setName('');
      setDescription('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create team');
    } finally {
      setLoading(false);
    }
  };
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <style>{styles}</style>
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="h5 mb-0">Create New Team</h3>
          <button 
            onClick={onClose} 
            className="btn btn-link text-decoration-none text-secondary"
          >
            <FiX size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-4">
          {error && (
            <div className="error-alert">
              {error}
            </div>
          )}

          <div className="mb-3">
            <label className="form-label">Team Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="form-control"
              placeholder="e.g., Frontend Team"
              required
              minLength="3"
            />
          </div>

          <div className="mb-4">
            <label className="form-label">Description (Optional)</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="form-control"
              rows="3"
              placeholder="What does this team do?"
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-outline-secondary"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
            >
              {loading ? 'Creating...' : 'Create Team'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateTeamModal;